export class MoovDefinitionCustomerAdoptionDTO{
    public id!:number;
    public customerId!:number;
    public moovDefinitionId!:number;
    public usageTypeOverride?:number;
    public usagePriceOverride?:number;
    public billingBucketIdOverride?:number;
}